import { render, staticRenderFns } from "./addprotocol.vue?vue&type=template&id=0e0888d2"
import script from "./addprotocol.vue?vue&type=script&lang=ts"
export * from "./addprotocol.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports